(function () {
    'use strict';
    angular.module('swif.framework')


    /**
        * @ngdoc service
        * @name swif.framework.settingsService
        * @description is responsible to fetch configuration from the server and provide it.
     * These settings are saved in default.json. Not so easy to change. So we also use swifOpenbaseCompanyService
    **/
    .factory('settingsService', [
        '$q', '$localStorage', '$location', '$http', function ($q, $localStorage, $location, $http) {
            console.log('init settingsService');
            return new SettingsService($q, $localStorage, $location, $http);
        }
    ])

    .provider('settingsService', function settingsServiceProvider () {
        var defaultSettings = {};
        this.addSettings = function (settings) {
            console.log('provider add !!');
            defaultSettings = _.merge(defaultSettings, settings);
        };
        this.$get = ['$q', '$localStorage', '$location', '$http',
            function settingsFactory ($q, $localStorage, $location, $http) {
                return new SettingsService($q, $localStorage, $location, $http, defaultSettings);
            }
        ];
    });


    function SettingsService ($q, $localStorage, $location, $http, defaultSettings) {
        this.localStorage = $localStorage;
        this.app = {initialized: false};
        this.loading = {
            app: {loading: false, ok: false, ko: false}
        };
        this.DATE_KEYWORDS = ['FIRSTDAYWEEK', 'LASTDAYWEEK', 'FIRSTDAYMONTH', 'LASTDAYMONTH', 'OVERMONTH', 'OUTDATED'];

        this.page = {};
        this.onInitialized = [];
        //cleanup old version
        _.forEach(['authenticated_user', 'token', 'authenticated_user_data', 'cart'], function (key) {
            if ($localStorage[key]) {
                delete $localStorage[key];
            }
        });
        this.set = function (key, value) {
            $localStorage[this.app.db][key] = value;
        };
        this.get = function (key) {
            if (this.app.db){
                return $localStorage[this.app.db][key];
            }
        };
        this.delete = function (key) {
            if (this.app.db){
                delete $localStorage[this.app.db][key];
            }
        };
        this.reset = function () {
            $localStorage[this.app.db] = {cart:{}};
        };
        this.getDB = function () {
            return this.app.db;
        };
        this.getAPIURL = function () {
            var l = window.location;
            var baseurl = l.protocol + '//' + l.host;
            return baseurl;
        };
        this.setAPIURL = function (url) {
            $localStorage.url = url;
        };
        this.getContentType = function (contentType) {
            return this.app.contentTypes[contentType];
        };
        this.getContentTypeFromModel = function (model) {
            var self = this;
            var contentType;
            _.forEach(self.app.contentTypes, function (ct) {
                if (ct.model === model) {
                    contentType = ct;
                }
            });
            return contentType;
        };
        this.isDebugMode = function () {
            return this.app.debug || $location.search().debug ? true : false;
        };
        this._initialize = {};
        this.initialize = function () {
            var self = this;
            if (self.app.initialized) {
                return $q.when(self);
            } else {
                var onError = function (error) {
                    alert(JSON.stringify(error));
                    _.forEach(self.onInitialized, function (callback) {
                        callback(error);
                    });
                };
                var random = Math.random();
                if (self._initialize.p) {
                    return self._initialize.p;
                }
                self._initialize.p = $http.get('configuration.json?' + random).then(function (config) {
                    return $http.get('default.json?' + random).then(function (defaultConfig) {

                        if (defaultSettings) {
                            _.merge(self.app, defaultSettings);
                        }
                        if (defaultConfig.data) {
                            _.merge(self.app, defaultConfig.data);
                        }
                        if (config.data) {
                            // case of custom contentType. for example custom pdf printing
                            if (config.data.contentTypeCustomAction) {
                                _.forEach(config.data.contentTypeCustomAction, (content_type) => {
                                    if (content_type.action_type) {
                                        // find the id of the custom content_type
                                        let actionIndex = self.app.contentTypes[content_type.name].actions[content_type.action_type].findIndex(action => action.id === content_type.action_id)
                                        // override the action if it exists, or add it
                                        if (actionIndex >-1) {
                                            self.app.contentTypes[content_type.name].actions[content_type.action_type][actionIndex] = content_type.custom_content;
                                        } else {
                                            self.app.contentTypes[content_type.name].actions[content_type.action_type].push(content_type.custom_content);
                                        }
                                    }
                                    if (content_type.saveAsFields) {
                                        // Override the saveAsFields if it exists
                                        if (self.app.contentTypes[content_type.name]) {
                                            self.app.contentTypes[content_type.name].saveAsFields = content_type.saveAsFields
                                        }
                                    }
                                });
                            }
                            delete config.data.contentTypeCustomAction;
                            // case of custom contentType. for example custom pdf printing
                            if (config.data.contentTypes) {
                                _.forEach(config.data.contentTypes, (content_type) => {
                                    if (content_type.saveAsFields) {
                                        // Override the saveAsFields if it exists
                                        if (self.app.contentTypes[content_type.name]) {
                                            self.app.contentTypes[content_type.name].saveAsFields = content_type.saveAsFields
                                        }
                                    }
                                });
                            }
                            _.merge(self.app, config.data);
                        }
                        self.app.initialized = true;
                        if (!$localStorage[self.app.db]) {
                            self.reset();
                        }
                        _.forEach(self.onInitialized, function (callback) {
                            callback(null, self);
                        });
                        return self;
                    }, onError);
                }, onError);
                return self._initialize.p;
            }
        };
    }


})();
